export default __webpack_public_path__ + "static/media/include_12@2x.529262f3.jpg";